<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      entity-name="DailyReport"
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-action="false"
      :use-default-action="false"
      icon="mdi-cards"
    />
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import dailyReprot from '@/model/dataLayer/api/statistic/dailyReprot'

export default {
  name: 'DailyStatistics',
  components: {
    IkDataTable
  },
  data () {
    return {
      model: dailyReprot
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {

      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
